import { useI18n } from '../../i18n/I18nProvider';
import { ModalDialog } from '../../ui/Dialog';
import { ItemForm, type SavedItem } from './ItemForm';

export { CustomTaxDialog, LabeledSegment, type SavedItem } from './ItemForm';

/**
 * The item form in a centred dialog: the container used by the Today setup checklist
 * (DESIGN_SYSTEM §6a). The form mounts fresh each time the dialog opens.
 */
export function ItemDialog({
  orgId,
  isOpen,
  onOpenChange,
  itemId,
  onSaved,
}: {
  orgId: string;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  itemId?: string | null;
  onSaved: (item: SavedItem) => void;
}) {
  const { t } = useI18n();
  return (
    <ModalDialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={itemId ? t.catalogue.editTitle : t.catalogue.newTitle}
      wide
    >
      <ItemForm
        orgId={orgId}
        itemId={itemId ?? null}
        onSaved={(item) => {
          onSaved(item);
          onOpenChange(false);
        }}
        onCancel={() => onOpenChange(false)}
      />
    </ModalDialog>
  );
}
